import { Controller } from "@hotwired/stimulus"

// Positions a desktop menu dropdown directly below its trigger. The vertical
// offset is always computed from the trigger's live geometry — so it stays
// correct wherever the trigger is relocated. Horizontally the panel follows the
// menu's alignment: page-centred while the menu is centred (by the logo), or
// aligned to the trigger once the menu drops to its own left-aligned row.
export default class extends Controller {
  static targets = ["panel"]

  position() {
    // The panel is absolutely positioned, so its offsets are relative to its
    // offsetParent (the nearest positioned ancestor — the navbar when the menu
    // is in its own row, but Row 1 when the menu sits by the logo).
    const parent = this.panelTarget.offsetParent
    if (!parent) return
    const trigger = this.element.getBoundingClientRect()
    const origin = parent.getBoundingClientRect()
    this.panelTarget.style.top = `${trigger.bottom - origin.top}px`

    if (this.#centred) {
      this.panelTarget.style.left = "50%"
      this.panelTarget.style.transform = "translateX(-50%)"
    } else {
      this.panelTarget.style.left = `${trigger.left - origin.left}px`
      this.panelTarget.style.transform = ""
    }
  }

  // The menu's <ul> carries justify-center while centred by the logo and
  // justify-start once it relocates to its own row (toggled by relocate-search).
  get #centred() {
    return this.element.closest("ul")?.classList.contains("justify-center") ?? false
  }
}
